import { render, staticRenderFns } from "./PopupAddCampaign.vue?vue&type=template&id=2bb0fdc4&"
import script from "./PopupAddCampaign.vue?vue&type=script&lang=js&"
export * from "./PopupAddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddCampaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports